import { render, staticRenderFns } from "./DmrBlock.vue?vue&type=template&id=69be2e77&scoped=true&"
import script from "./DmrBlock.vue?vue&type=script&lang=js&"
export * from "./DmrBlock.vue?vue&type=script&lang=js&"
import style0 from "./DmrBlock.vue?vue&type=style&index=0&id=69be2e77&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69be2e77",
  null
  
)

export default component.exports